<template>
    <div class="app-container" style="background-color: #f9fbff;">
        <div class="review-title-content">
            <div class="reasons-title">
                <h3>お湯が出ない.comの口コミ</h3>
            </div>
        </div>
        <div class="card">
            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                    <span class="under-yellow">「親切で信頼できる業者さんです！」</span>    
                </p>
                <p class="review-content-text">
                    修理が必要な箇所や交換の必要性をしっかり説明してくれたので、納得してお願いできました。
                </p>
                <p class="review-content-text">
                    <span class="under-yellow">無理な営業もなく、誠実な対応がとても印象的でした。</span>
                </p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                   良心的な価格で満足！
                </p>
                <p class="review-content-text">
                    <span class="under-yellow">他社と比較しても料金が明確で、追加費用もなく安心してお願いできました。</span>
                </p>
                <p class="review-content-text">
                    作業もスムーズで、仕上がりも完璧でした。ありがとうございました！
                </p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                    <span class="under-yellow">急にお湯が出なくなり困っていましたが、問い合わせたその日に対応していただきました。</span>
                </p>
                <p class="review-content-text">
                    説明も丁寧で安心してお任せできました。これからも何かあればお願いしたいと思います！
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.app-container {
    background: #f9fbff;
    padding: 40px 20px;
}

.reasons-title {
    margin-bottom: 30px;
    text-align: center;
}

.reasons-title h3 {
    font-size: 32px;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
    background: linear-gradient(90deg, #3f51b5, #3F51B5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.reasons-title h3::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #3f51b5;
    margin: 12px auto 0;
    border-radius: 2px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.review-content {
    background: #fff;
    padding: 25px 20px;
    border: 1px solid #eee;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}

.review-header {
    margin-bottom: 12px;
}

.rating-point-box {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;
}

.rating-stars {
    color: #ffc107;
    font-size: 18px;
    letter-spacing: 2px;
}

.rating-score {
    font-size: 18px;
    font-weight: bold;
    color: #d9534f;
}

.google-review {
    text-align: right;
    font-size: 12px;
    padding-bottom: 0;
    margin-bottom: 0;
}

.review-header img {
    width: 60px;
    height: auto;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .review-content-text {
        font-size: 0.9rem;
    }

    .google-review {
        font-size: 0.7rem;
    }

    .rating-point-box img {
        width: 20%;
    }

    .rating-stars,
    .rating-score {
        font-size: 0.9rem;
    }

    .reasons-title h3 {
        font-size: 1.5rem
    }

    .rating-stars {
        font-size: 1.2rem;
    }
}
</style>
